import InstancesFilters from './InstancesFilters';

export default InstancesFilters;
